import { css } from 'linaria';

export const storageDesignCardGrid = css`
  grid-row-gap: 16px;
`;

export const cardHeaderStyle = css`
  && {
    max-width: 398px;

    @media (--to-desktop) {
      max-width: 278px;
    }

    @media (--only-tablet) {
      max-width: 245px;
      font-size: 20px;
      line-height: 26px;
    }

    @media (--only-mobile) {
      max-width: 100%;
      font-size: 18px;
      line-height: 24px;
    }
  }
`

export const cardLogo = css`
  && {
    @media (--to-desktop) {
      inset: 32px auto auto 24px;
      width: 80px;
      height: 80px;
    }
  }
`;

export const  storageDesignCard = css`
  && {
    @media (--only-tablet) {
      width: 100%;
      min-height: auto;
      padding: 128px 32px 32px;
    }

    @media (--only-mobile) {
      width: 100%;
      min-height: auto;
      padding: 128px 24px 24px;
    }
  }
`;

export const cardDescriptionStyle = css`
  && {
    max-width: 398px;

    @media (--only-desktop) {
      max-width: 278px;
    }

    @media (--only-tablet) {
      max-width: 250px;
    }

    @media (--only-mobile) {
      max-width: 100%;
    }
  }
`;
